import styled, { createGlobalStyle } from 'styled-components';

const blue = props => props.theme.jj.blue.primary;
const darkBlue = props => props.theme.jj.blue.dark;

export const Wrapper = styled.div`
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin: 0 auto;
  }
`;

export const GlobalStyle = createGlobalStyle`
  html, body {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body > img {
    position: absolute;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    background: #ffffff;
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: subpixel-antialiased;
  }

  ::placeholder {
    color: #aab1c7;
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: #aab1c7;
  }

  ::-ms-input-placeholder {
    color: #aab1c7;
  }

  @-ms-viewport {
    width: device-width;
  }

  article,
  aside,
  dialog,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  nav,
  section {
    display: block;
  }

  body {
    margin: 0;
    font-family: "Brandon Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #183558;
    text-align: left;
    background-color: #ffffff;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4 {
    ${'' /* color: ${darkBlue}; */}
    font-weight: 700;
    letter-spacing: -0.03em;
    line-height: 95%;
    margin: 0;
    text-align: center;
    text-transform: uppercase;
  }

  a {
    color: ${blue};
    text-decoration: none;
  }
  a:hover {
    color: ${darkBlue};
  }

  img {
    vertical-align: middle;
    border-style: none;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  /*
  Using minimal specificity when possible. BodyWrapper has more
  specificity than a tag name, so we can bump up specificity for
  this rule by selecting headers within any other element.
  */
  body h1, body h2, body h3, body h4 {
    font-family: 'Brandon Text Black', 'Brandon Text', sans-serif;
  }

  h1 {
    font-size: 48px;
    font-weight: 900;

    @media (min-width: 768px) {
      font-size: 80px;
    }
    @media (min-width: 1024px) {
      font-size: 100px;
    }
    @media (min-width: 1440px) {
      font-size: 124px;
    }
  }

  h2 {
    font-size: 32px;
    font-weight: 900;
    margin-bottom: 16px;

    @media (min-width: 768px) {
      margin-bottom: 24px;
      font-size: 42px;
    }

    @media (min-width: 1024px) {
      font-size: 56px;
    }
  }

  h3 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;

    @media (min-width: 768px) {
      font-size: 28px;
    }
  }

  p {
    text-align: left;
    line-height: 150%;
    font-size: 16px;
    ${'' /* color: #121210; */}

    @media (min-width: 768px) {
      margin: 0;
      font-size: 20px;
    }
  }






  
`;
